import * as React from 'react';
import { History } from 'history';
import { Button, Card, FormHeader } from '.';

interface Props {
  history?: History;
  id?: string;
  caption: string;
  captionColor?: any;
  captionThin?: boolean;
  buttonCaption?: string;
  buttonColor?: any;
  buttonOnBottom?: boolean;
  cardColor?: any;
  cardGradientColor?: any;
  onSubmit?: (data: any) => void;
  disableBackButton?: boolean;
  disableCard?: boolean;
  children?: React.ReactNode;
}

export const Form: React.FunctionComponent<Props> = (props) => {
  const historyState: any = props.history?.location.state;
  const isSubmit = props.buttonCaption?.trim() || props.onSubmit;

  const displayButton = (margin: number) => {
    const buttonCaption = props.buttonCaption || 'submit';
    if (props.buttonCaption?.trim()!=='')
        return <Button type='contained' label={buttonCaption} color={props.buttonColor} sx={{marginTop: margin, marginBottom: margin}} onClick={props.onSubmit} />      
  }

  const children = () => {
    return (
      <>
        {props.children}
        {props.buttonOnBottom && displayButton(3)}
      </>
    )
  }

  const child = () => {
    return (        
      <>
        <FormHeader history={props.history} label={props.caption} color={props.captionColor} thin={props.captionThin} disableBackButton={props.disableBackButton}>  
          {!props.buttonOnBottom && displayButton(0)}
        </FormHeader>
        {props.disableCard? children() : <Card color={props.cardColor} gradientColor={props.cardGradientColor}> {children()} </Card>}
      </>
    );
  }
    
  const childWithForm = () => {
    return (
      <form id={props.id || historyState?.id} onSubmit={e => e.preventDefault()}> {child()} </form>
    )
  }

  return (        
    <> {(props.children || props.buttonCaption?.trim() !== '') && (isSubmit? childWithForm() : child()) } </>
  );
}
